import create from 'zustand';
import { isEmpty } from 'lodash-es';
import { fetchIn, saveIn } from 'GrooveLocalStorage';
import {
  FlowFilters,
  initialFlowFilters,
} from '@groove/ui/Components/FlowFilters/constants';

const loadInitialFilters = (): FlowFilters => {
  const savedFilters = fetchIn(['flowFilters']);

  if (!isEmpty(savedFilters)) {
    const syncedFilters: FlowFilters = { ...initialFlowFilters };
    Object.keys(initialFlowFilters).forEach(key => {
      if (key !== 'status' && key !== 'searchTerm')
        syncedFilters[key] = savedFilters[key] || initialFlowFilters[key];
      else if (key !== 'searchTerm') syncedFilters[key] = savedFilters[key];
    });
    return syncedFilters;
  }
  return initialFlowFilters;
};

export type FlowFiltersStore = {
  flowFilters: FlowFilters;
  selectedFlowIds: number[];
  allFlowsSelected: boolean;
  updateFlowFilters: (newFilters: FlowFilters, persist?: boolean) => void;
  resetFlowFilters: () => void;
  reloadFlowFilters: () => void;
  setSelectedFlowIds: (newFlowIds: number[]) => void;
  selectAllFlows: (selected: boolean) => void;
  bulkActionDialogs: Record<string, boolean>;
  setBulkActionDialogs: (dialog: Record<string, boolean>) => void;
  resetSelectedFlows: () => void;
};

const useFlowStore = create<FlowFiltersStore>(set => ({
  flowFilters: loadInitialFilters(),
  selectedFlowIds: [],
  allFlowsSelected: false,
  setSelectedFlowIds: (newFlowIds: number[]) =>
    set({ selectedFlowIds: newFlowIds }),
  updateFlowFilters: (newFilters: FlowFilters, persist = true) => {
    if (persist) saveIn(['flowFilters'], newFilters);
    set({ flowFilters: newFilters });
  },
  resetFlowFilters: () => set({ flowFilters: initialFlowFilters }),
  reloadFlowFilters: () => set({ flowFilters: loadInitialFilters() }),
  selectAllFlows: selected => set({ allFlowsSelected: selected }),
  bulkActionDialogs: {},
  setBulkActionDialogs: (dialog: Record<string, boolean>) => {
    set({ bulkActionDialogs: dialog });
  },
  resetSelectedFlows: () =>
    set({ allFlowsSelected: false, selectedFlowIds: [] }),
}));

export default useFlowStore;
